(function () {
    const popup = document.getElementById('how-it-works-popup');
    if (!popup) return;
  
    const openBtn = document.querySelector('[data-how-it-works-open]');
    const closeBtns = popup.querySelectorAll('[data-how-it-works-close]');
    const backdrop = popup.querySelector('.how-it-works-popup__backdrop');
  
    function openPopup() {
      popup.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      popup.querySelector('.how-it-works-popup__close')?.focus();
    }
  
    function closePopup() {
      popup.setAttribute('hidden', '');
      document.body.style.overflow = '';
      openBtn?.focus();
    }
  
    openBtn?.addEventListener('click', openPopup);
    closeBtns.forEach(function (el) {
      el.addEventListener('click', closePopup);
    });
    if (backdrop) backdrop.addEventListener('click', closePopup);
  
    popup.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePopup();
    });
  })();
  